import React from 'react';
import './HowToPlay.css';

// COME SI GIOCA — la sezione che sta nella staging area al posto del white paper.
//
// Il white paper spiegava la tokenomics a chi valuta il progetto. Chi e' fermo
// nella staging area col wallet collegato ha gia' deciso: gli serve sapere come
// si muove, cosa raccoglie e come porta a casa i soldi.
//
// Il testo e' in inglese come il resto della dashboard e come le scritte che si
// leggono in partita (BOOST, CASH OUT, EXTRACTED SAFELY): una guida che chiama
// le cose con nomi diversi da quelli sullo schermo non serve a niente.
//
// Ogni numero qui dentro e' quello vero del motore (GameEngine.js): durate dei
// power-up, secondi del cash-out, tassa, valore delle palline. Se cambiano li',
// vanno cambiati qui — una guida che mente e' peggio di nessuna guida.

// I power-up, con gli stessi colori e le stesse icone che hanno in partita
// (MainScene.POWERUP_STYLES): la legenda serve a riconoscerli sul campo, quindi
// deve somigliare a quello che si vede sul campo.
const POWERUPS = [
  {
    icon: '👁',
    color: '#00FFFF',
    name: 'VISION',
    time: '8s',
    text: 'The camera pulls back: you see far more of the arena than anyone else.',
  },
  {
    icon: '⚡',
    color: '#FF0000',
    name: 'SPEED',
    time: '5s',
    text: 'Boost speed without paying for it in mass.',
  },
  {
    icon: '🧲',
    color: '#FF00FF',
    name: 'MAGNET',
    time: '8s',
    text: 'The pull cone in front of your mouth gets much longer and much stronger.',
  },
  {
    icon: '✖',
    color: '#FFD700',
    name: '2X',
    time: '10s',
    text: 'Base food grows you twice as fast. It does not double your SOL — that only comes from white orbs.',
  },
  {
    icon: '📡',
    color: '#39FF14',
    name: 'RADAR',
    time: '12s',
    text: 'Enemies show up on the minimap, including the ones off screen.',
  },
];

const CONTROLS = [
  { key: 'MOUSE', action: 'Steer: your head follows the pointer. On mobile, the joystick.' },
  { key: 'TAP / SPACE', action: 'Boost. Double speed, but it burns mass for as long as you hold it.' },
  { key: 'E', action: 'Use the power-up in your pocket.' },
  { key: 'C', action: 'Start the CASH OUT.' },
  { key: 'L', action: 'Open and close the leaderboard.' },
];

const HowToPlay = () => (
  <div className="htp">
    <h1 className="glitch-title glitch-text htp-title" data-text="HOW TO PLAY">HOW TO PLAY</h1>

    <div className="htp-content">
      <p className="htp-lead">
        You drop into a circular arena with your stake on the line. Grow, take down the other
        operatives, collect what they leave behind — and <strong>get out before someone does
        the same to you</strong>. Die and everything you are carrying hits the ground for
        whoever comes next.
      </p>

      <section>
        <h2>Controls</h2>
        <div className="htp-comandi">
          {CONTROLS.map((c) => (
            <div className="htp-comando" key={c.key}>
              <kbd>{c.key}</kbd>
              <span>{c.action}</span>
            </div>
          ))}
        </div>
      </section>

      <section>
        <h2>What is on the ground</h2>

        <div className="htp-voce">
          <span className="htp-orb htp-orb--cibo" aria-hidden="true" />
          <div>
            <h3>Base food <em>— coloured orbs</em></h3>
            <p>
              These <strong>only make you grow</strong>: zero SOL. Still worth eating, because a
              long body is ground the others have to steer around. Your snake stops getting
              bigger at a certain point; your SOL do not — those keep climbing.
            </p>
          </div>
        </div>

        <div className="htp-voce">
          <span className="htp-orb htp-orb--soldi" aria-hidden="true" />
          <div>
            <h3>Loot <em>— white orbs</em></h3>
            <p>
              The money dropped by whoever just died. Each orb is worth
              <strong> 10% of the room stake</strong>, in SOL, and goes straight into your
              score. <strong>This is the only way to earn in a match:</strong> eat nothing but
              base food and you end up huge and broke.
            </p>
          </div>
        </div>

        <div className="htp-voce">
          <span className="htp-orb htp-orb--powerup" aria-hidden="true" />
          <div>
            <h3>Power-ups <em>— discs with an icon</em></h3>
            <p>
              You carry <strong>one at a time</strong> and trigger it with E. While your pocket
              is full you pick up no others: they stay where they are.
            </p>
          </div>
        </div>

        <div className="htp-powerups">
          {POWERUPS.map((p) => (
            <div className="htp-powerup" key={p.name} style={{ '--pu': p.color }}>
              <span className="htp-powerup-icona">{p.icon}</span>
              <div>
                <h4>{p.name} <span className="htp-durata">{p.time}</span></h4>
                <p>{p.text}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section>
        <h2>How you die</h2>
        <ul className="htp-morti">
          <li>
            <strong>The arena edge.</strong> The red zone is a circle, and touching it is final.
            Nothing bounces you back.
          </li>
          <li>
            <strong>Firewalls.</strong> The mines scattered across the map. They kill on contact
            and blast your loot outward in a wide fan around the crater: someone else will reach
            part of it before you do.
          </li>
          <li>
            <strong>Head to head.</strong> Whoever arrives <strong>face first</strong> dies. Get
            clipped on the side of the head, or from behind, and you survive with the kill —
            straight head-on and you both go.
          </li>
          <li>
            <strong>Another operative&apos;s body.</strong> Run into someone&apos;s tail and you
            die, not them. Cutting people off is the main weapon in this game.
          </li>
          <li>
            <strong>Spawn shield:</strong> you are invulnerable for the first 3 seconds.
            Boosting breaks it early.
          </li>
        </ul>
      </section>

      <section>
        <h2>Cash out — getting paid</h2>
        <p>
          Press <kbd className="htp-kbd-inline">C</kbd> and <strong>survive 3 seconds</strong>.
          While extracting you <strong>cannot steer</strong>, and boosting cancels the whole
          thing: you call it looking at where everyone else is, not on a whim.
        </p>
        <p>
          Make it and you keep your entire score minus a <strong>10% tax on profit only</strong>
          — your entry stake comes back untouched. Die first and you take home nothing: whatever
          you had piled up stays on the field.
        </p>
      </section>
    </div>
  </div>
);

export default HowToPlay;
